import ax from "../axios";
// 接口列表
export const _getMenuList = (params) => ax.get("/api/level/getlist", params);   //菜单
export const _getBannerImgList = (params) => ax.get("/api/link/getlist", params);   //焦点图片
export const _getArticleList = (params) => ax.get("/api/article/getlist", params);  //获取文章列表
export const _toSearch = (params) => ax.get("/api/article/search", params);  //搜索
export const _getauxiliaryinfo = (params) => ax.get("/api/link/getauxiliaryinfo", params);   //获取辅助参数
export const _getArticleDetail = (params) => ax.get("/api/article/detail", params);   //获取文章详情
export const _saveMessageBoard = (data) => ax.post("/api/messageboard/save", data);   //留言板提交



// WEBPACK FOOTER //
// ./src/api/services/InterfaceConfigurationPage.js